const SERIALISE_KEYS = ['character', 'onboarded', 'stars'];
const MODEL_ID = 'player';

export default class PlayerModel {
  constructor(saves) {
    this.saves = saves;
    this.levelSelect = false;
    this.reset();
    this.load();
  }

  reset() {
    this.character = '';
    this.onboarded = [];
    this.stars = {};
  }

  /*
   * Save Methods
   */
  load() {
    this.saves.deserialize(this, MODEL_ID);
    this.save();
  }

  isOnboarded(id) {
    return this.onboarded.includes(id);
  }

  setOnboarded(id) {
    if (!this.isOnboarded(id)) {
      this.onboarded.push(id);
      this.save();
    }
  }

  getStars(id) {
    return this.stars[id] || 0;
  }

  setStars(id, stars) {
    if (this.getStars(id) < stars) {
      this.stars[id] = stars;
      this.save();
    }
  }

  save() {
    const data = this.saves.serialize(this, MODEL_ID, SERIALISE_KEYS);
    this.saves.save({ data });
  }
}
